import apiClient from '../config/api';

const settingsService = {
  /** Get current user's general preferences */
  getGeneralSettings: async () => {
    const response = await apiClient.get('/settings/general');
    return response.data;
  },

  /** Update current user's general preferences */
  updateGeneralSettings: async (prefs) => {
    const response = await apiClient.post('/settings/general', prefs);
    return response.data;
  },
};

export default settingsService;
